import React from 'react';

// Small line icons for the desk pet's ask box and thought bubble, drawn like
// Bailey's widgets (skills/widgets/icons.jsx).
const I = ({ size = 16, stroke = 1.8, children }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{children}</svg>
);

const IDEA_ICONS = {
  calendar: <><rect x="3.5" y="5" width="17" height="15" rx="3" /><path d="M3.5 10h17M8 3v4M16 3v4" /></>,
  palette: <><path d="M12 3a9 9 0 100 18c1.1 0 1.7-.9 1.4-1.8-.4-1.1.3-2.2 1.5-2.2H17a4 4 0 004-4c0-5.5-4-10-9-10z" /><circle cx="7.5" cy="11" r="1.2" /><circle cx="10.5" cy="7" r="1.2" /><circle cx="15" cy="7.5" r="1.2" /></>,
  sparkle: <path d="M12 3.5c.6 4 2.5 5.9 6.5 6.5-4 .6-5.9 2.5-6.5 6.5-.6-4-2.5-5.9-6.5-6.5 4-.6 5.9-2.5 6.5-6.5z" />,
  chart: <path d="M5 20v-8M11 20V5M17 20v-5M3 20h18" />,
  photo: <><rect x="3.5" y="3.5" width="17" height="17" rx="4" /><circle cx="9" cy="9.5" r="1.6" /><path d="M20.5 15l-4.5-4.5-8.5 9" /></>,
  chat: <path d="M20 12a8 8 0 01-11.6 7.1L4 20l1-4.1A8 8 0 1120 12z" />,
};

export const IdeaIcon = ({ name }) => <I>{IDEA_ICONS[name] || IDEA_ICONS.chat}</I>;
export const ArrowRight = ({ size = 14 }) => <I size={size} stroke={2}><path d="M5 12h14M13 6l6 6-6 6" /></I>;
export const ArrowUp = ({ size = 16 }) => <I size={size} stroke={2.4}><path d="M12 19V5M5 12l7-7 7 7" /></I>;
export const Close = ({ size = 14 }) => <I size={size} stroke={2}><path d="M6 6l12 12M18 6L6 18" /></I>;
export const Tick = ({ size = 12 }) => <I size={size} stroke={3}><path d="M5 12.5l4.2 4.2L19 7" /></I>;
